import { makeAutoObservable } from "mobx";
import { RArray } from "../../collections";
import { RDate } from "../../core";
export class OrderingHours {
    constructor(params) {
        this.weeklySchedule = params.weeklySchedule;
        makeAutoObservable(this);
    }
    fulfillmentDates(date) {
        // TODO: limit by vacations
        const result = this.weeklySchedule
            .dayOfWeek(date.weekday)
            .timeRanges.map((timeRange) => {
            let fromDate = RDate.fromDateAndTime(date, RDate.fromTimeString(timeRange.from.toString(), date.tz));
            const toDate = RDate.fromDateAndTime(date, RDate.fromTimeString(timeRange.to.toString(), date.tz));
            const result = [];
            while (fromDate.isBefore(toDate)) {
                result.push(fromDate);
                fromDate = fromDate.add(30, "minutes");
            }
            return result;
        })
            .flat();
        return new RArray(result).drop(2);
    }
}
